import { useWebsocketUpdates } from "@finbackoffice/site-core";
import { HoursRange, IClientError, IEventFeedResponse } from "@finbackoffice/websocket-client";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { sortBySportId } from "@finbackoffice/fe-core";
import Loading from "components/base/loading/Loading";
import SportGamesContent from "components/pages/home/sport-games/content/SportGamesContent";

interface IEventsState {
    data: IEventFeedResponse[];
    loading: boolean;
}

type IProps = {
    hoursRange: HoursRange;
    sliderSpeed: number;
};

const PrematchTopWidget: FC<IProps> = ({ hoursRange, sliderSpeed }) => {
    const [activeSportId, setActiveSportId] = useState<number | null>(null);
    const [events, setEvents] = useState<IEventsState>({
        data: [],
        loading: true,
    });
    const [isFallback, setIsFallback] = useState(false);

    const onSocketUpdate = useCallback((events: IEventFeedResponse[], error: IClientError) => {
        if (!error) {
            if (events.length) {
                setEvents({
                    data: events,
                    loading: false,
                });
            } else {
                setIsFallback(true);
            }
        } else {
            setEvents((state) => ({
                ...state,
                loading: false,
            }));
        }
    }, []);

    const payload = useMemo(
        () => ({ hours: !isFallback ? hoursRange : HoursRange.FORTY_EIGHT }),
        [hoursRange, isFallback],
    );

    useWebsocketUpdates("top", onSocketUpdate, true, payload);

    useEffect(() => {
        if (events && events.data.length) {
            const selectedSportDoesNotExist =
                activeSportId &&
                events.data.findIndex((event) => event.sport_id === activeSportId) === -1;

            if (events.data.length && (!activeSportId || selectedSportDoesNotExist)) {
                setActiveSportId(events.data.sort(sortBySportId)[0].sport_id);
            }
        } else {
            setActiveSportId(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [events]);

    const onSportClickHandler = useCallback((sportId: number) => {
        setActiveSportId(sportId);
    }, []);

    if (events.loading) return <Loading />;

    return (
        <SportGamesContent
            events={events.data}
            activeSportId={activeSportId}
            onSportClickHandler={onSportClickHandler}
            sliderSpeed={sliderSpeed}
        />
    );
};

export default PrematchTopWidget;
